import { FC, ReactNode } from 'react';
import { Divider, Popover, Typography } from 'antd';
import dayjs from 'dayjs';

import style from './index.module.less';

const { Text } = Typography;

const FROZEN_COLOR = '#aaaaaa';
const AUTO_COMPLETE_DAYS = 60;

const FrozenPopoverContent: FC<{ since?: string }> = ({ since }) => {
  const sinceDate = since ? dayjs(since) : null;
  const autoCompleteDate = sinceDate ? sinceDate.add(AUTO_COMPLETE_DAYS, 'day') : null;

  return (
    <div className={style.card}>
      <div className={style.header}>
        <span className={style.dot} />
        <span className={style.title}>Frozen</span>
      </div>

      {sinceDate && (
        <>
          <Text type="secondary" className={style.label}>Active since</Text>
          <div className={style.date}>{sinceDate.format('MMM D, h:mm A')}</div>
          <Text type="secondary" className={style.relative}>{`${dayjs().diff(sinceDate, 'day')} days ago`}</Text>

          <Divider className={style.divider} />

          <Text type="secondary" className={style.label}>Auto-completes at</Text>
          <div className={style.date}>{autoCompleteDate!.format('MMM D, h:mm A')}</div>
          <Text type="secondary" className={style.relative}>{`in ${autoCompleteDate!.diff(dayjs(), 'day')} days`}</Text>
        </>
      )}
    </div>
  );
};

interface FrozenPopoverProps {
  item: any;
  children: ReactNode;
}

const FrozenPopover: FC<FrozenPopoverProps> = ({ item, children }) => {

  if (!item.ghosted) {
    return <>{children}</>;
  }

  return (
    <Popover
      content={<FrozenPopoverContent since={item.current_temperature_since} />}
      trigger="hover"
      placement="bottom"
      destroyTooltipOnHide
    >
      <span style={{ overflow: 'hidden', display: 'block' }}>{children}</span>
    </Popover>
  );
};

export { FROZEN_COLOR };
export default FrozenPopover;
